<wk-settings-breadcrumb />
<div class="container wk-sat__container">
    <div class="wk-sat__toolbar">
        <div class="row">
            <div class="col-md-5 wk-sat__toolbar-timeframe">
                <div>{{ "AuditTrail.TimeFrame" | translate }}</div>
                <select (change)="onTimeFrameChange($event.target.value)">
                    <option disabled selected>{{ "AuditTrail.SelectTimeFrame" | translate }}</option>
                    <option value="1">{{ "AuditTrail.TimeFrameOption1" | translate }}</option>
                    <option value="2">{{ "AuditTrail.TimeFrameOption2" | translate }}</option>
                    <option value="3">{{ "AuditTrail.TimeFrameOption3" | translate }}</option>
                </select>
            </div>
            <div class="col-md-5 wk-sat__toolbar-operations">
                <div>{{ "AuditTrail.Operations" | translate }}</div>
                <select (change)="onDashboardChange($event.target.value)">
                    <option selected value="">{{ "AuditTrail.OperationsOnUsers" | translate }}</option>
                    @for (dashboard of dashboards; track dashboard.Id) {
                        <option value="{{ dashboard.Id }}">{{ dashboard.Title }}</option>
                    }
                </select>
            </div>
            <div class="col-md-2 wk-sat__toolbar__controls">
                <button class="primary wk-sat__toolbar__controls-refresh" (click)="refreshData()" [disabled]="!selectedTimeFrame">
                    @if (isLoading) {
                        <app-loader [isOverlay]="false" size="button" />
                    }
                    {{ "AuditTrail.Refresh" | translate }}
                </button>
            </div>
        </div>
    </div>

    <kendo-grid
        [data]="gridView"
        [loading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        [pageable]="{
            buttonCount: pagerButtonCount,
            info: pagerInfo,
            type: type,
            pageSizes: pageSizes,
            previousNext: previousNext,
            position: position,
        }"
        (pageChange)="pageChange($event)"
        >>
        <kendo-grid-column [width]="350" field="user" title="{{ 'AuditTrail.User' | translate }}"></kendo-grid-column>
        <kendo-grid-column field="action" title="{{ 'AuditTrail.Action' | translate }}"></kendo-grid-column>
        <kendo-grid-column [width]="400" field="entity" title="{{ 'AuditTrail.Entity' | translate }}"></kendo-grid-column>
        <kendo-grid-column [width]="200" field="timestamp" title="{{ 'AuditTrail.Time' | translate }}"></kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            {{ "AuditTrail.NoRecords" | translate }}
        </ng-template>
    </kendo-grid>
</div>
